// drafts/slice.js

import { activeDelDraftsInitialState } from "./activeDelsDraftsState";
import { makeActiveDelDraftsActions } from "./activeDelsDraftsActions";

export const createActiveDelDraftsSlice = (set, get) => ({
  activeDelDrafts: activeDelDraftsInitialState,
  activeDelDraftsActions: Object.freeze(makeActiveDelDraftsActions(set, get)),
});
